import React from 'react'
import { useNavigate } from 'react-router-dom'
import FooterComponent from '../FooterComponent/FooterComponent'
import Header from '../HeaderComponent/Header'
import Menu from '../MenuComponent/Menu'
import './addnewclient.css'

export default function ClientList() {
	const navigate = useNavigate();
	const AddNewClients = () =>{
		navigate('/add-new-client')
	}
  return (
<React.Fragment>
    <div class="mid">
	<div class="container-fluid">		
		<div class="head">
			<h3>Client List</h3>
			
			<div class="dropdown fltr">
				<button type="button" class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>							
				<div class="dropdown-menu dropdown-menu-end" aria-labelledby="fillist">
					<form>									
						<div class="filters">
							<label for="status">Status:</label>
							<select data-placeholder="..." multiple class="chosen-select" tabindex="8" id="status">
								<option value="2">Active</option>
								<option value="3">Inactive</option>
								<option value="1">Disabled</option>
							</select>
						</div>
						<div class="filters">
							<label for="select-state">From Date:</label>
							<input type="date" value="" name="" id=""/>
						</div>
						
						<div class="filters">
							<label for="select-state">To Date:</label>
							<input type="date" value="" name="" id=""/>
						</div>

						<div class="fbtn">
							<button class="btn" type="submit" id="btna">Apply</button>
							<button class="btn" type="reset" id="btnc">Clear</button>
						</div>
					</form>
				</div>
			</div>
			
			<button class="btn" type="button" onClick={AddNewClients}>Add New Client</button>
						
			<div class="headsearch">
				<div class="input-group">
					<input type="text" class="form-control" placeholder="Search client..."/>
					<button class="btn search" type="button" id="txnsrch">search</button>
				</div>
			</div>
		</div>
		
		<div class="clntlist">
			<div class="row">
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp1.png')}  alt="logo"/>
								<h5>Butterfly Sea Corporation Limited</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp2.png')}  alt="logo"/>
								<h5>HDFC Bank India Pvt. Ltd.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp3.png')} alt="logo"/>
								<h5>HDFC Bank India Pvt. Ltd.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="inactive">inactive Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp4.png')} alt="logo"/>
								<h5>Starbucks Corporation of India</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="inactive">inactive Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp5.png')} alt="logo"/>
								<h5>Fidelity National Information Services, Inc.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp6.png')} alt="logo"/>
								<h5>Tata Motors and Engineering Ltd.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp7.png')} alt="logo"/>
								<h5>Wipro Information Technology Limited</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp8.png')} alt="logo"/>
								<h5>Insta-Burger King, Inc</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="disable">Disabled Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp9.png')} alt="logo"/>
								<h5>Bharti Airtel Limited</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp10.png')} alt="logo"/>
								<h5>HDFC Bank India Pvt. Ltd.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp1.png')} alt="logo"/>
								<h5>HDFC Bank India Pvt. Ltd.</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="inactive">inactive Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12 col-md-6 col-lg-4">	
					<div class="listcard">
						<button type="button" onclick="window.location.href='profile.html'">
							<div class="clname">
								<img src={require('../../assests/images/corp1.png')} alt="logo"/>
								<h5>Organic India Pvt Ltd</h5>
								<p>Client ID: 9891865123</p>
							</div>							
							<div class="clta">
								<h6>TA Balance: <span>₹ 34,234.00 </span></h6>
								<p class="active">Active Client</p>
							</div>
						</button>
					</div>
				</div>
				
				<div class="col-12">				
					<div class="pager">
						<p>Showing 1 to 12 of 45 entries <button class="lbbtn" type="button">Export</button></p>
						
						<ul class="pagination pagination-sm">
							<li class="page-item"><a class="page-link" href="#">Prev</a></li>
							<li class="page-item active"><a class="page-link" href="#">1</a></li>
							<li class="page-item"><a class="page-link" href="#">2</a></li>
							<li class="page-item"><a class="page-link" href="#">3</a></li>
							<li class="page-item"><a class="page-link" href="#">4</a></li>
							<li class="page-item"><a class="page-link" href="#">Next</a></li>
						</ul>					
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

</React.Fragment>
  )
}
